<template>
    <div class="hidden lg:flex w-12 cursor-pointer mr-2" @click="toggleCart">
        <img :src="'/icons/icon_cart.svg'">
        <span v-if="cartCount > 0" class="self-end text-xs text-white bg-green rounded font-bold px-1">{{ cartCount
            }}</span>

    </div>
</template>

<script>

import { cart, mutations } from "./cart";


export default {
    data() {
        return {
            cart: cart,
        }
    },
    computed: {
        cartCount() {
            return this.cart.items.length;
        }
    },
    methods: {
        toggleCart() {
            mutations.toggleCart();
        }
    }
}
</script>
